import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import CustomModal from "components/lib/customModal";
import { Row } from "components/lib/customModal/customModal.styles";
import { Button, theme, Spinner } from "@mindlercare/ui-web";
import { Typography } from "components/typography";
import { useAssignIcbt } from "./assignIcbtContext";

export const RowCenter = styled(Row)`
  justify-content: center;
  align-items: baseline;
  gap: 10px;
`;
// TODO: fix
const ModalTopMarginFixWrapper = styled.div`
  margin-top: -10px;
`; // Custom modal wrapper has some stupid hard coded defaults

export const ConfirmAssignIcbtsModal = ({
  setModalIsOpen,
  open,
  handleAssignIcbts,
  patientName,
  isSubmitting,
}: {
  setModalIsOpen: (arg: boolean) => void;
  open: boolean;
  handleAssignIcbts: () => Promise<void>;
  patientName: string;
  isSubmitting: boolean;
}) => {
  const { t } = useTranslation();

  const { state: assignIcbtState } = useAssignIcbt();
  const { programsToAssign } = assignIcbtState.assignState;

  const programsToBeAssignedTotalCount =
    Object.values(programsToAssign).flat().length;

  const handleCancel = () => {
    setModalIsOpen(false);
  };

  const handleAccept = async () => {
    await handleAssignIcbts();
    setModalIsOpen(false);
  };

  return (
    <CustomModal.Wrapper
      onClose={() => setModalIsOpen(false)}
      open={open}
      size="small"
      isScrollable={true}
    >
      <ModalTopMarginFixWrapper>
        <Typography
          variant="h3"
          sx={{ textAlign: "center" }}
          data-testid="popupText"
        >
          {t("ASSIGN_ICBT_CONFIRM", {
            count: programsToBeAssignedTotalCount,
            patientName,
          })}
        </Typography>
        <RowCenter>
          <Button
            variant="secondary"
            onClick={handleCancel}
            disabled={isSubmitting}
            testId="popupCancelButton"
          >
            <Typography
              variant="body"
              sx={{ fontWeight: theme.FONT.WEIGHT.MEDIUM }}
              insensitive
            >
              {t("CANCEL")}
            </Typography>
          </Button>
          <Button
            variant="primary"
            onClick={handleAccept}
            style={{ alignItems: "center" }}
            disabled={isSubmitting}
            testId="popupAssignButton"
          >
            <Typography
              variant="body"
              sx={{ fontWeight: theme.FONT.WEIGHT.MEDIUM }}
              insensitive
            >
              {t("ASSIGN")}
            </Typography>
          </Button>
        </RowCenter>
        {isSubmitting ? (
          <RowCenter>
            <Spinner />
          </RowCenter>
        ) : null}
      </ModalTopMarginFixWrapper>
    </CustomModal.Wrapper>
  );
};
